import {
	assicurazioneRCOptions,
	vetturaSostitutivaAllOptions,
} from './stellantisConstants';

export const buildQuoteRequestGtmPayload = (values: any) => {
	const treniGomme = `Treni Gomme estive ${values.numTrenoGommeEstive} - Treni Gomme invernali ${values.numTrenoGommeInvernali}`;
	const hasGomme = !!values.gommeYN;

	return {
		mobility_services: {
			Manutenzione: 'Si',
			Gomme: {
				quality_performance:
					hasGomme && values.tipoGomma === 'quality' ? treniGomme : 'No',
				premium: hasGomme && values.tipoGomma === 'premium' ? treniGomme : 'No',
				gomme_illimitate: values.gommeIllimitateYN ? 'Si' : 'No',
			},
			Vettura_Sostitutiva: values.autoSostitutivaYN
				? vetturaSostitutivaAllOptions.find(
						(option) => option.value === values.autoSostitutivaGruppo
				  )?.label ?? 'No'
				: 'No',
		},
		insurance_services: {
			RCA:
				assicurazioneRCOptions.find(
					(option) => option.value === Number(values.rcaPenaleRisarcitoria)
				)?.label ?? 'No',
			Kasko: `${values.kaskoFranchigia}€`,
			theft_fire: `${values.incendioFurtoScopertoPerc}%`,
		},
		rental_duration: values.durata,
		km_years: values.kmAnnui,

		supply: values.alimentazione,
		notes: values.requestNote,
		customer_type: values.tipoCliente,

		item_name: `${values.marca} - ${values.modello} ${values.allestimento}`,
		item_category: values.marca,
		item_category2: `${values.modello} ${values.allestimento}`,
		advance: values.anticipoNoIva,
		// Canone target facoltativo inserito dall'utente, non una quotazione restituita.
		price: Number(values.canone) || 0,
		provvigioni: values.provvigioni,
	};
};
